import { createStore } from 'vuex';
import { filters } from '@/pages/search/-src/vuex/filtersModule';

const store = createStore({
  state() {
    return {}; 
  },
  mutations: {},
  modules: {
    filters,
  },
});

export default defineNuxtPlugin((nuxtApp) => {
  nuxtApp.vueApp.use(store);
});